import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={16} height={11} fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M5.563 8.913L13.925.55a.812.812 0 111.149 1.15l-8.938 8.937a.812.812 0 01-1.149 0L.925 6.575a.813.813 0 011.15-1.15l3.487 3.488z" fill="#9738FF" /></svg>;
}
export default SvgComponent;